export default __webpack_public_path__ + "static/media/recreio.373e278f.jpg";